import { useCallback } from 'react';
import { useStoreActions } from '@/store';
import { ImagePanelFeatureType } from '@/types';

export const getTrackFunc = (data: any, attribute = '', firstId?: string): string => {
    const { id, func } = data;
    let result = `${firstId ?? id}_${func}`;
    if (attribute) {
        const val = data[attribute];
        if (val) {
            result = `${result}_${val}`;
        }
    }
    return result;
};

export const useCardMenuTrack = (TRACK_CONFIG: any, firstId?: string) => {
    const getRecordInfo = useStoreActions((actions) => actions.recordModel.getRecordInfo);

    const onToggleHandle = useCallback(
        (feature: ImagePanelFeatureType, isOpen: boolean) => {
            if (!isOpen) return;
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, undefined, firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: +isOpen,
                click_type: 0,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onSliderHandle = useCallback(
        (feature: ImagePanelFeatureType, type: string, click_type = 1, hideTick = false) => {
            console.log('【细节】：', feature);
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, type, firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: 1,
                click_type,
                record_id: getRecordInfo().id,
            });
            if (!hideTick) {
                window._stat_track('hb_layers_func_use', {
                    func_id,
                    record_id: getRecordInfo().id,
                });
            }
        },
        [firstId],
    );

    const onResetHandle = useCallback(
        (feature: ImagePanelFeatureType) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, 'reset', firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: 1,
                click_type: 1,
                record_id: getRecordInfo().id,
            });
            window._stat_track('hb_layers_func_use', {
                func_id,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onAttrChangeHandle = useCallback(
        (feature: ImagePanelFeatureType, attr: string, click_type: number) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, attr, firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: 1,
                click_type,
                record_id: getRecordInfo().id,
            });
            if (click_type) {
                window._stat_track('hb_layers_func_use', {
                    func_id,
                    record_id: getRecordInfo().id,
                });
            }
        },
        [firstId],
    );

    const onSelectHandle = useCallback(
        (feature: ImagePanelFeatureType, index: number, type?: string) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, 'select', firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: 1,
                click_type: 1,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onTabHandle = useCallback(
        (feature: ImagePanelFeatureType, type: string) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, `tab_${type}`, firstId);
            window._stat_track('hb_layers_func_click', {
                func_id,
                open: 1,
                click_type: 1,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onEliminateHandle = useCallback(
        (feature: ImagePanelFeatureType, penType: string) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, penType, firstId);
            window._stat_track('hb_layers_func_use', {
                func_id,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onTickHandle = useCallback(
        (feature: ImagePanelFeatureType, type: string) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, type, firstId);
            window._stat_track('hb_layers_func_use', {
                func_id,
                record_id: getRecordInfo().id,
            });
        },
        [firstId],
    );

    const onClickTickHandle = useCallback(
        (feature: ImagePanelFeatureType, type: string) => {
            const trackCode = TRACK_CONFIG[feature];
            const func_id = getTrackFunc(trackCode, type, firstId);

            window._stat_track('hb_layers_func_click', {
                func_id,
                record_id: getRecordInfo().id,
            });
            window._stat_track('hb_layers_func_use', {
                func_id,
                record_id: getRecordInfo().id,
            });
            return func_id;
        },
        [firstId],
    );

    const onTrackTickHandle = useCallback((trackFunc: string, isTick = false) => {
        window._stat_track('hb_layers_func_use', {
            func: trackFunc,
            record_id: getRecordInfo().id,
        });
    }, []);

    return {
        getTrackFunc,
        onToggleHandle,
        onSliderHandle,
        onResetHandle,
        onAttrChangeHandle,
        onSelectHandle,
        onTabHandle,
        onEliminateHandle,
        onTickHandle,
        onClickTickHandle,
        onTrackTickHandle,
    };
};
